/**
 * The site's charging docks (`dockPlaces`), from the two cached queries that
 * already name and place them: the task catalog's `charge` places and the
 * place registry. No request of its own -- both are static reference data
 * the dispatch form and the maps already read.
 */
import { useMemo } from 'react';
import { usePlaces } from '../../api/hooks/usePlaces';
import { useTaskCatalog } from '../../api/hooks/useTaskCatalog';
import { dockPlaces, type DockPlace } from './dock-places';

export function useDockPlaces(): readonly DockPlace[] {
  const catalog = useTaskCatalog();
  const places = usePlaces();
  return useMemo(() => dockPlaces(catalog.data, places.data), [catalog.data, places.data]);
}
